import {AfternoonIcon, EarlyMorningIcon, EveningIcon, NightIcon} from "src/assets/Icons";
import i18n from "src/i18n";
import { getNumberLocale } from "src/utility";

const formatHour = (hour: number) => new Intl.NumberFormat(getNumberLocale(), { minimumIntegerDigits: 2 }).format(hour);
const hourRange = (fromHour: number, toHour: number) => `${formatHour(fromHour)}:${formatHour(0)}-${formatHour(toHour)}:${formatHour(0)}`;

export const TIME_SEGMENTS = [
  {
    icon: <span className="text-3xl "><NightIcon className="w-5 h-5" /></span>,
    get title() {
      return i18n.t("Filters.timeSegments.night");
    },
    get subTitle() {
      return hourRange(0, 6);
    },
    offsetFrom: 0,
    offsetTo: 5,
  },
  {
    icon: <span className="text-3xl"><EarlyMorningIcon className="w-5 h-5" /></span>,
    get title() {
      return i18n.t("Filters.timeSegments.morning");
    },
    get subTitle() {
      return hourRange(6, 12);
    },
    offsetFrom: 6,
    offsetTo: 11,
  },
  {
    icon: <span className="text-3xl"><AfternoonIcon className="w-5 h-5" /></span>,
    get title() {
      return i18n.t("Filters.timeSegments.afternoon");
    },
    get subTitle() {
      return hourRange(12, 18);
    },
    offsetFrom: 12,
    offsetTo: 17,
  },
  {
    icon: <span className="text-3xl"><EveningIcon className="w-5 h-5" /></span>,
    get title() {
      return i18n.t("Filters.timeSegments.evening");
    },
    get subTitle() {
      return hourRange(18, 24);
    },
    offsetFrom: 18,
    offsetTo: 23,
  },
];
